import { render, staticRenderFns } from "./RewardItem.vue?vue&type=template&id=29b74f72"
import script from "./RewardItem.vue?vue&type=script&lang=js"
export * from "./RewardItem.vue?vue&type=script&lang=js"
import style0 from "./RewardItem.vue?vue&type=style&index=0&id=29b74f72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_vue-template-compiler@2.7.16_webpack@5.89.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports